import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  withStyles,
  Typography,
  Grid,
} from '@material-ui/core';

export const styles = () => ({
  container: { margin: 5 },
  cardCenter: { textAlign: 'center' },
  root: { flexGrow: 1 },
  typeContainer: { maxWidth: 200 },
  control: { padding: 4 },
});

export class TagInformationCardComponent extends React.Component {
  render() {
    return (
      <Grid container justify="center" className={this.props.classes.container}>
        <Grid item>
          <h3 className={this.props.classes.cardCenter}>
            <small>
              Tags can be used to provide different groupings and filters when tied to Events
            </small>
          </h3>
          <p className={this.props.classes.cardCenter}>
            Tags can be anything. Create Tags that represent categories, levels, locations, severities,
            or anything else you might need to better understand the Event you tied it to.
            There are no limits on the Tags your create.
          </p>

          <h4>Name</h4>
          <div>
            <p>
              The <b>Name</b> of the Tag is used as the main
              descriptor. This name is displayed
              along with any Event it gets tied to.
            </p>
          </div>

          <h4>Tag Hierarchy</h4>
          <div>
            <p>
              Tags can either be a <b>root</b> tag or
              a <b>child</b> tag. You have free range to move Tags
              into any parent child relationship you see fit for
              the tags your are defining. There is no limit on the
              number of levels you can create.
            </p>
            <br />
            <Typography gutterBottom variant="caption">
              <b>Example: </b>A example hierarchy could be locations.
              Assume you want to represent a tag for every location in your building.
              You can create a <b>root</b> tag for the building itself. Then, create
              a <b>child</b> tag for each subsequent area you want represented in
              the building.
            </Typography>
            <ul style={{ listStyle: 'none' }}>
              <li>My Building</li>
              <ul style={{ listStyle: 'none' }}>
                <li>Floor 1</li>
                <ul style={{ listStyle: 'none' }}>
                  <li>Room A</li>
                  <li>Room B</li>
                </ul>
                <li>Floor 2</li>
              </ul>
            </ul>
          </div>

          <h4>Tag Types</h4>
          <div>
            <p>
              Each Tag must be assigned a Tag Type. Tag Types are
              just as it sounds, a type for a tag. You can create
              as many Tag Types as you wish. Then when creating a
              Tag, you can assign it to one of those types.
            </p>
            <br />
            <p>
              Tag Types help describe the Tags you assign to an Event.
              You can provide a Name, Icon, and Color for each Type.
              This information is then displayed along with a Tag
              name to help distinguish it.
            </p>
            <br /><br />
            <Typography gutterBottom variant="caption">
              In the example of creating Tags to represent a building
              and all the areas within the building, you might want
              a Tag Type called <b>Location</b> to better describe those tags.
              You can then reuse that same Tag Type when creating additional
              tag locations, maybe for different buildings.
            </Typography>
          </div>

          <h4>Archiving</h4>
          <div>
            <p>
              You can archive Tags at any time. If you no longer wish
              to use a Tag with new Events, you can use this feature.
            </p>
            <br />
            <p>
              <b>Archiving</b> does not remove the Tag permanently,
              but instead will hide it from being used in new Event
              creation in the Dashboard. You can always un-archive
              the tag and bring it back to use.
            </p>
            <br />
            <p>
              <b>Note</b> you cannot archive a tag that has active
              Events tied to it. You will first need to complete those
              Events or remove the tag from the active Event before archiving.
            </p>
          </div>
        </Grid>
      </Grid>
    );
  }
}

TagInformationCardComponent.propTypes = { classes: PropTypes.object.isRequired };

export default connect()(withStyles(styles, { withTheme: true })(TagInformationCardComponent));
